import $ from 'cash-dom';
import {headerComponent} from "./components/header";
import {animeFloatComponent} from "./components/animeFloat";
import {validate} from "./systems/validate";
import {phoneInputComponent} from "./components/phoneInput";
import {formComponent} from "./components/form";
import {postalCodeInputComponent} from "./components/postalCodeInput";
import {contactApi} from "./api/contactApi";
import {anchorScrollComponent} from "./components/anchorScroll";

import "./bootstrap";
import {popupComponent} from "./components/popup";
import anime from "animejs/lib/anime.es.js";
import {storageSystem} from "./systems/storage";
import {errorComponent} from "./components/error";

const storage = storageSystem('index-contact').createItems(['email', 'phone']);

$(document).ready(() => {
    const errorMessages = {
        name: {message: 'Meno a priezvisko sú povinné', root: '#name-input'},
        email: {message: 'E-mailová adresa je povinná', root: '#email-input'},
        phone: {message: 'Telefónne číslo je nesprávne', root: '#phone-input'},
        postal_code: {message: 'Poštovné smerovacie číslo je nesprávne', root: '#postal_code-input'},
        note: {message: 'Odkaz je nesprávny', root: '#note-input'},
        agree_personal_information: {
            message: 'Musíte súhlasiť so spracovaním osobných údajov',
            root: '#agree_personal_information-input'
        },
        agree_marketing: {
            message: 'Musíte súhlasiť so spracovaním osobných údajov na účel realizácie marketingových aktivít',
            root: '#agree_marketing-input'
        },
    };

    animeFloatComponent();
    headerComponent();
    anchorScrollComponent();
    errorComponent();
    const successPopup = popupComponent('#success-popup');

    phoneInputComponent('#contact_phone', {
        onValid(value) {
            storage.phone.set(value);
        },
    });
    postalCodeInputComponent('#contact_postal_code');

    const onSubmit = async data => {
        const $form = $('#contact_form');
        const submit = $form.find('.submit').get(0);
        const success = $form.find('.success').get(0);

        $form.find('.error').each((i, e) => e.style.display = 'none');
        $form.find('input').each((i, e) => e.disabled = true);
        anime({
            targets: '#contact',
            color: '#7A7AAD',
            duration: 300,
            easing: 'easeInOutSine',
        });
        anime({
            targets: submit,
            opacity: 0,
            duration: 150,
            easing: 'easeInSine',
            complete() {
                submit.style.display = 'none';
                success.style.opacity = '0';
                success.style.display = 'flex';
            },
        });

        const result = await contactApi('index', data);

        anime({
            targets: success,
            opacity: 1,
            duration: 150,
            easing: 'easeOutSine',
        })
    };

    const onErrors = errors => {
        Object.entries(errors).forEach(([field, isValid]) => {
            const errorMessage = errorMessages[field];
            // console.log(field);
            if (errorMessage.root) {
                const $ele = $(errorMessage.root);
                const error = $ele.find('.error').get(0);
                const errorContent = $ele.find('.error-content').get(0);

                if (!isValid) {
                    error.style.display = 'flex';
                    errorContent.innerText = errorMessage.message;
                } else {
                    error.style.display = 'none';
                }
            }
        });
    };

    const {
        any,
        phone,
        postalCode,
        email,
        required,
    } = validate;

    const form = formComponent('#contact_form', {
        fields: [
            {name: 'name', type: 'text', validate: required()},
            {
                name: 'email',
                type: 'text',
                validate: email(),
                onValid(value) {
                    storage.email.set(value);
                },
            },
            {
                name: 'phone',
                type: 'phone',
                validate: phone(),
                onValid(value) {
                    storage.phone.set(value);
                },
            },
            {name: 'postal_code', type: 'phone', validate: postalCode()},
            {name: 'note', type: 'text', validate: any()},
            {name: 'agree_personal_information', type: 'checkbox', validate: required()},
            {name: 'agree_marketing', type: 'checkbox', validate: required()},
        ],
        onSubmit,
        onErrors,
    });
});
